import { useContext } from "react";
import { useStore } from "@ludens-reklame/rubics-v3-react/store/hooks";
import { transformImageUrl } from "@ludens-reklame/rubics-v3-sdk/file/utils";
import { ThemeSettings } from "../../types/theme.js";
import { AppContext } from "../../context/app-context.js";
import { Button } from "../../internal-components/button/button.js";

interface Props {}

const Header: React.FC<Props> = () => {
  const { themeSettings, site } = useStore<ThemeSettings>();
  const { spawnContactFormModal } = useContext(AppContext);
  const headerForm = themeSettings.headerForm || undefined;

  return (
    <header className="header">
      <div className="container">
        <div className="hs">
          <div className="content">
            {site.logo && (
              <a href="/" className="logo">
                <img
                  src={transformImageUrl(site.logo, { height: 90 })}
                  alt={site.name}
                />
              </a>
            )}

            {!!headerForm && (
              <Button onClick={() => spawnContactFormModal(headerForm)}>
                Kontakt oss
              </Button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
